// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

import * as helper from './../../../Assets/Js/helper';

helper.addEventListener(window, 'load', () => {
	const links = helper.$('.paytourOpener');
	for (let link of links) {
		helper.addEventListener(link, 'click', function (evt) {
			evt.preventDefault();
			let paytourHelper = window.paytourHelper;
			let paytourInitObject = {
				'targetUrl': '',
				'pfm': 1502,
				'hideClose': false,
				'disableJump': false,
				'customizedSignup': 'tvabo',
				'login': 1
			};
			paytourHelper.openVXTVAbo(paytourInitObject);
		});
	}
});
